import { useState } from 'react';

/**
 * @param {Object} [props]
 * @param {boolean} [props.defaultIsOpen]
 * @param {Function} [props.onHidden]
 *
 */
const useModal = ({ defaultIsOpen = false, onHidden } = {}) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  function openModal(e) {
    if (e.ctrlKey || e.metaKey) {
      return;
    }

    e.preventDefault();
    setIsOpen(true);
  }

  function hideModal() {
    setIsOpen(false);
    onHidden?.();
  }

  return [isOpen, openModal, hideModal];
};

export default useModal;
